<template>
	<div full-height grey-back>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
		    <v-toolbar-title class="white--text">{{$root.CurrentBusiness.IsAccountantOnly ? 'User Profile' : 'Business Profile'}}</v-toolbar-title>
		    <v-spacer></v-spacer>
		    <v-btn icon @click="fn_editBusiness">
		    	<v-icon>edit</v-icon>
		    </v-btn>
		</v-toolbar>

		<div class="form-element hasToolbar">

            <v-list two-line v-if="$root.CurrentBusiness.IsAccountantOnly">

				<v-list-tile>
					<v-list-tile-content>
						<v-list-tile-sub-title>Your Name</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.UserName ? $root.CurrentBusiness.UserName : '-'}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile>
					<v-list-tile-content>
						<v-list-tile-sub-title>State</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.State}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

			</v-list>

			<v-list two-line v-else>

				<v-list-tile>
					<v-list-tile-content>
						<v-list-tile-sub-title>Business Name</v-list-tile-sub-title>
                        <v-list-tile-title>{{$root.CurrentBusiness.BusinessName}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile>
					<v-list-tile-content>
						<v-list-tile-sub-title>Business Owner Name</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.UserName ? $root.CurrentBusiness.UserName : '-'}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile class="multiline-text-tile">
					<v-list-tile-content>
						<v-list-tile-sub-title>Address</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.Address ? $root.CurrentBusiness.Address : '-'}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

                <!-- <v-list-tile>
					<v-list-tile-content>
						<v-list-tile-sub-title>Email</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.Email ? $root.CurrentBusiness.Email : '-'}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile> -->

				<v-list-tile>
					<v-list-tile-content>
						<v-list-tile-sub-title>State</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.State}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile>
					<v-list-tile-content>
						<v-list-tile-sub-title>Pincode</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.Pincode ? $root.CurrentBusiness.Pincode : '-'}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile>
					<v-list-tile-content>
						<v-list-tile-sub-title>Business Profile Number</v-list-tile-sub-title>
						<v-list-tile-title>{{fn_businessProfileNumber()}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile>
					<v-list-tile-content>
						<v-list-tile-sub-title>GST Registration Status</v-list-tile-sub-title>
						<v-list-tile-title>
							{{$root.CurrentBusiness.GSTRegistrationStatus == 1 ? 'Registered - Regular' : $root.CurrentBusiness.GSTRegistrationStatus == 2 ? 'Registered - Composite' : 'Unregistered'}}
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<v-list-tile v-if="$root.CurrentBusiness.GSTRegistrationStatus == 1 || $root.CurrentBusiness.GSTRegistrationStatus == 2">
					<v-list-tile-content>
						<v-list-tile-sub-title>GST Number</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.GSTNumber ? $root.CurrentBusiness.GSTNumber : '-'}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>

				<!-- <v-list-tile v-if="$root.CurrentBusiness.GSTRegistrationStatus == 1">
					<v-list-tile-content>
						<v-list-tile-sub-title>HSN Applicable</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.HSNApplicable ? 'Yes' : 'No'}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile> -->

				<v-list-tile v-if="$root.CurrentBusiness.GSTRegistrationStatus == 1">
					<v-list-tile-content>
						<v-list-tile-sub-title>Tax Type</v-list-tile-sub-title>
						<v-list-tile-title>{{$root.CurrentBusiness.TaxMode == 1 ? 'Exclusive' : $root.CurrentBusiness.TaxMode == 2 ? 'Inclusive' : 'None'}}</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</div>

	</div>
</template>

<script>

	export default{
		methods: {
			fn_editBusiness: function(){
	            this.$router.push({path:'/registration/business/'+this.$root.CurrentBusiness.BusinessID+'/edit'});
	        },

	        fn_businessProfileNumber: function(){
	        	let prefix = this.$root.CurrentBusiness.BusinessProfileNumber.substring(0, 2);
	        	let suffix = this.$root.CurrentBusiness.BusinessProfileNumber.substring(2, 12);
	        	return "+" + prefix + ' - ' + suffix;
	        },

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
		
		mounted: function(){
			window.js_globals.fn_onBackPress = this.fn_goBack;
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/registration/business_details.vue